module.exports = __webpack_public_path__ + "img/aib_logo.0176425c.png";